import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesWideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"slides-wide-add"} maskId="square-filled-radius-0-stroke-1-IconSlidesWideAdd"><path fillRule="evenodd" clipRule="evenodd" d="M19 4H2V17H5V20H22V7H19V4ZM3 16H5V7H18V5H3V16ZM10 14V13H13V10H14V13H17V14H14V17H13V14H10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSlidesWideAdd;
